import { connect } from 'react-redux';
import idx from 'idx';
import { isCollaborator, getParticipationForbiddenReason } from 'project/utils';
import { getProject } from 'project/ducks/project';
import ParticipationPermsCallout from 'project/components/participation_perms_callout';

export const mapStateToProps = (state) => {
  const user = state.user.profile_data;
  const project = getProject(state);
  const forbiddenReason = getParticipationForbiddenReason(state);

  return {
    show: (
      project.status === "open" &&
      !!user.id &&
      !user.is_staff &&
      user.id !== project.client &&
      !isCollaborator(project) &&
      !!forbiddenReason
    ),
    forbiddenReason
  };
};

export default connect(mapStateToProps)(ParticipationPermsCallout);



// WEBPACK FOOTER //
// ./project/containers/participation_perms_callout.js